import { FC, useEffect } from 'react';
import { useStore } from 'react-admin';
import { Card, Container, Tab, Tabs } from '@mui/material';
import { listContainerStyles } from '../../../styles';
import { EducationLevelGroup, SUBJECT_TYPE } from '../../../constants';
import EducationLevelSubjects from './EducationLevelSubjects';
import { ToolbarActions } from './ToolbarActions';
import { useAuthProvider, useRefresh } from 'react-admin';
import { HighSchoolAndBaseRoles, JuniorSchoolAndBaseRoles, PreSchoolAndBaseRoles } from 'src/constants/roles';

const SubjectsList: FC = () => {
    const [activeTab, setActiveTab] = useStore<EducationLevelGroup | null>('subjectListTab', null);

    const refresh = useRefresh();
    const authProvider = useAuthProvider();

    useEffect(() => {
        if (!activeTab) {
            let tab: EducationLevelGroup | null = null;
            if (authProvider?.containsRoles(PreSchoolAndBaseRoles)) {
                tab = EducationLevelGroup.PRESCHOOL;
            } else if (authProvider?.containsRoles(JuniorSchoolAndBaseRoles)) {
                tab = EducationLevelGroup.JUNIOR_SCHOOL;
            } else if (authProvider?.containsRoles(HighSchoolAndBaseRoles)) {
                tab = EducationLevelGroup.HIGH_SCHOOL;
            }
            setActiveTab(tab);
        }
    }, [activeTab, setActiveTab]);

    if (!activeTab) {
        return null;
    }

    return (
        <Container sx={listContainerStyles}>
            <ToolbarActions />
            <Card>
                <Tabs value={activeTab} onChange={(e, value) => setActiveTab(value)}>
                    {authProvider?.containsRoles(PreSchoolAndBaseRoles) && (
                        <Tab value={EducationLevelGroup.PRESCHOOL} label="Дошкільна освіта" />
                    )}
                    {authProvider?.containsRoles(JuniorSchoolAndBaseRoles) && (
                        <Tab value={EducationLevelGroup.JUNIOR_SCHOOL} label="1-4 класи" />
                    )}
                    {authProvider?.containsRoles(HighSchoolAndBaseRoles) && (
                        <Tab value={EducationLevelGroup.HIGH_SCHOOL} label="5-11 класи" />
                    )}
                    {authProvider?.containsRoles(HighSchoolAndBaseRoles) && (
                        <Tab value={SUBJECT_TYPE.PSYCHOLOGY} label="Освітня послуга (психологія)" />
                    )}
                </Tabs>
                <EducationLevelSubjects educationLevelGroup={activeTab} reloadKey={true} refresh={refresh} />
            </Card>
        </Container>
    );
};

export default SubjectsList;
